import { Fragment } from "react"

import { Box } from "@mui/material"

export default function StripeLayout({children,onboarding}) {
    return(
        <Box sx={{marginTop:onboarding ? '0px' : '-124px'}}>
            <Fragment >
                <Box
                    sx={{
                        minHeight: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: 'linear-gradient(to right, #ffffff 0%, #f3f5f8 50%, #ffffff 65%)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            width: '110%',
                            height: '82%',
                            zIndex: 1,
                            background: 'linear-gradient(to right, #f5f7ff 0%, #ebeef9 10%, #f5f7ff 90%)',
                            clipPath: 'polygon(0 0, 100% 0, 100% 60%, 50% 100%, 0 60%)',
                            overflow: 'hidden',

                        }}
                    ></Box>

                    {/* Curved Background Shape */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            width: '110%',
                            height: '65%',
                            backgroundColor: '#6C63FF',
                            zIndex: 2,
                            background: 'linear-gradient(to right, #7db7ff 0%, #6d67ff 50%, #7cb6ff 70%)',
                            clipPath: 'polygon(0 0, 100% 0%, 100% 54%, 50% 100%, 0 54%)',

                        }}
                    ></Box>

                </Box>
                <Box
                    sx={{
                        position: 'absolute',
                        top:'100px',
                        left: '50%',
                        transform: 'translate(-50%, 0px)',
                        boxSizing:'border-box',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        marginBottom:'120px',
                        zIndex: 3,
                    }}
                >                    
                {children}
                </Box>
            </Fragment>
        </Box>
    )
}
